<template>
  <div class="columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile">
    <search-album-list-item
      v-for="album in albums"
      v-bind:key="album.id"
      v-bind:album="album"
    ></search-album-list-item>
  </div>
</template>

<script>
  import SearchAlbumListItem from '@/components/SearchAlbumListItem'

  export default {
    name: 'SearchAlbumList',
    components: {
      SearchAlbumListItem
    },
    props: {
      albums: {
        type: Array,
        required: true
      }
    }
  }
</script>
